module.exports = __webpack_public_path__ + "static/media/noShopImg170x170.37f7aa39.svg";